import constantMember from '@/member/configs/constant'

const getDefaultState = () => {
  return {
    currentStep: constantMember.step_search1,
  }
}

const state = getDefaultState()

const mutations = {
  SET_CURRENT_STEP(state, payload) {
    state.currentStep = payload
  },
}

const actions = {
  async setCurrentStep({ commit }, payload) {
    let currentStep = constantMember.step_search1
    // 検索
    switch (payload.routeName) {
      case 'customer_info.search':
      case 'attachment.search':
      case 'mail_template.search':
      case 'partner.search':
      case 'custom_database.search':
      case 'account.search':
      case 'vehicle.search':
      case 'transport_company.search':
      case 'transporter.search':
      case 'center.search':
      case 'transporter_license.search':
      case 'transportation_result.search':
      case 'shipment_instruction.search':
      case 'shipper.search':
      case 'transport_instruction.search':
        currentStep = constantMember.step_search1
        break
      case 'customer_info.list':
      case 'mail_template.list':
      case 'partner.list':
      case 'attachment.list':
      case 'custom_database.list':
      case 'account.list':
      case 'vehicle.list':
      case 'transport_company.list':
      case 'transporter.list':
      case 'center.list':
      case 'center.berth.schedule':
      case 'transporter_license.list':
      case 'transportation_result.list':
      case 'shipment_instruction.list':
      case 'shipper.list':
      case 'transport_instruction.list':
        currentStep = constantMember.step_search2
        break
      case 'customer_info.detail':
      case 'customer_info.edit':
      case 'mail_template.detail':
      case 'mail_template.edit':
      case 'partner.detail':
      case 'partner.edit':
      case 'attachment.history':
      case 'attachment.update':
      case 'custom_database.detail':
      case 'custom_database.edit':
      case 'account.edit':
      case 'vehicle.detail':
      case 'vehicle.edit':
      case 'transport_company.detail':
      case 'transport_company.edit':
      case 'transport_company.price':
      case 'transporter.detail':
      case 'transporter.edit':
      case 'center.detail':
      case 'center.edit':
      case 'transporter_license.detail':
      case 'transportation_result.detail':
      case 'transportation_result.edit':
      case 'center.stocks':
      case 'shipment_instruction.detail':
      case 'shipment_instruction.edit':
      case 'shipper.detail':
      case 'shipper.scmap':
      case 'transport_instruction.detail':
      case 'transport_instruction.edit':
      case 'transporter.attendance':
      case 'vehicle.transportation_status':
      case 'transporter.status':
      case 'vehicle.co2_emission':
      case 'vehicle.device':
        currentStep = constantMember.step_search3
        break
      // 追加
      case 'attachment.upload':
      case 'mail_template.create':
      case 'partner.create':
      case 'customer_info.create':
      case 'customer_info.import':
      case 'custom_database.create':
      case 'customer_info.broadcast_email':
      case 'account.create':
      case 'customer_info.access_permission_list':
      case 'customer_info.access_permission_detail':
      case 'vehicle.create':
      case 'transport_company.create':
      case 'transporter.create':
      case 'center.create':
      case 'center.import':
      case 'transportation_result.create':
      case 'transport_instruction.create':
      case 'shipment_instruction.create':
      case 'shipment_instruction.import':
        currentStep = constantMember.step_add1
        break
      default:
        currentStep = constantMember.step_search1
    }

    commit('SET_CURRENT_STEP', currentStep)
  },
}

export default {
  state,
  mutations,
  actions,
}
